module.exports = __webpack_public_path__ + "img/hero-tablet.3ec0f30b.png";